<div class="fmnts-avatar__content">
  <ng-content select="fmnts-avatar-icon"></ng-content>
  <div class="fmnts-avatar__text">
    <ng-content></ng-content>
  </div>
</div>
